import React from 'react';

import template from 'url-template';

import { pingBasAgent, rebootAgent, restartAgentApplication } from '../actions/basAgentActions';
import {stopInventoryScan} from '../actions/inventoryActions';
import {connect} from 'react-redux';
import { isAllowed } from '../helpers/auth';
import { Permissions } from '../helpers/permissions';
import { isEmpty } from 'lodash';

import ActionsPanelItem from './ActionsPanelItem';
import SidebarPanel from './SidebarPanel';

import classes from './AgentActionsPanel.module.css';

const InventoryUrl = template.parse('/iothub/basagents/manage/inventory/{agentDriverType}{?company,basAgent}');

const BasInventoryUrl = (agent, companyInfo) => {
    if (!agent.driverConfiguration.length) {
        return;
    }

    let agentDriverType = agent.driverConfiguration[0].basType.toLowerCase();
    const company = companyInfo.companyId;
    const basAgent = agent.id;

    if (agentDriverType === 'bacnetip' || agentDriverType === 'bacnetethernet') {
        agentDriverType = 'bacnet';
    }

    return InventoryUrl.expand({
        agentDriverType,
        company,
        basAgent
    });
};

const AgentActionsPanel = ({
    agent,
    companyInfo,
    currentUser,
    currentScopes,
    history,
    isFullHubAllowed,
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    stopInventoryScan,
    toggleAssignAgentModal,
    toggleDeleteAgentModal,
    toggleFactoryResetModal,
    toggleLinkSitesModal,
    toggleRenameAgentModal,
    toggleTimeZoneModal,
    toggleUnAssignAgentModal
}) => {

    const deployment = agent.deployment.toLowerCase();

    const isAdminAccount = () => {
        const isCompanyAdmin = isAllowed(currentScopes, Permissions('adminFull'));
        const superAdmin = currentUser.isSuperUser || currentUser.email.toLowerCase().includes('@key2act.com');

        return isCompanyAdmin || superAdmin;
    };

    const handleStopInventoryScan = agent => {
        const {id, driverConfiguration} = agent;
        stopInventoryScan(id, driverConfiguration[0].id);
    };

    return (
        <SidebarPanel
            title="Agent Actions"
            titleIconSrc="/assets/images/agentActionsIconColor.svg"
        >
            <div className={classes.agentActions}>
                {
                    !isEmpty(agent.serialNumber) &&
                    <ActionsPanelItem
                        href={BasInventoryUrl(agent, companyInfo)}
                        title="View BAS Inventory"
                        iconUrl="/assets/images/devicesIconColor.svg"
                    />
                }
                {
                    isFullHubAllowed &&
                    <React.Fragment>
                        <ActionsPanelItem
                            href={`/iothub/basagents/manage/network?company=${companyInfo.companyId}&basAgent=${agent.id}`}
                            title="Configure BAS Network"
                            iconUrl="/assets/images/basConfigIconColor.svg"
                        />
                        {
                            deployment !== 'software' &&
                            <ActionsPanelItem
                                title="Reboot Agent"
                                iconUrl="/assets/images/rebootIconColor.svg"
                                onClick={() => rebootAgent(agent.id)}
                            />}
                        <ActionsPanelItem
                            title="Restart Application"
                            iconUrl="/assets/images/restartAppIcon.svg"
                            onClick={() => restartAgentApplication(agent.id)}
                        />
                        <ActionsPanelItem
                            onClick={() => pingBasAgent(agent.id)}
                            title="Ping Agent"
                            iconUrl="/assets/images/pingIconColor.svg"
                        />
                    </React.Fragment>
                }
                {
                    agent.serialNumber &&
                    process.env.advancedLogs &&
                    <ActionsPanelItem
                        href={`/iothub/basagents/manage/logs/advanced/network?company=${companyInfo.companyId}&basAgent=${agent.id}`}
                        title="View Logs"
                        iconUrl="/assets/images/logsIconColor.svg"
                    />
                }
                {
                    agent.serialNumber &&
                    !process.env.advancedLogs &&
                    <ActionsPanelItem
                        href={`/iothub/basagents/manage/logs/classic/network?company=${companyInfo.companyId}&basAgent=${agent.id}`}
                        title="View Logs"
                        iconUrl="/assets/images/logsIconColor.svg"
                    />
                }
                {
                    isFullHubAllowed &&
                    <React.Fragment>
                        <ActionsPanelItem
                            title="Rename Agent"
                            iconUrl="/assets/images/basAgentIconColor.svg"
                            onClick={() => toggleRenameAgentModal(true)}
                        />
                        <ActionsPanelItem
                            title="Update Agent Time Zone"
                            iconUrl="/assets/images/basAgentUpdateTimeZone.svg"
                            onClick={() => toggleTimeZoneModal(true)}
                        />
                        {
                            agent.serialNumber &&
                                <ActionsPanelItem
                                    title="Unassign Agent"
                                    iconUrl="/assets/images/unassignIconColor.svg"
                                    onClick={() => toggleUnAssignAgentModal(true)}
                                />
                        }
                        {
                            !agent.serialNumber &&
                                <ActionsPanelItem
                                    title="Assign Agent"
                                    iconUrl="/assets/images/assignIconColor.svg"
                                    onClick={() => toggleAssignAgentModal(true)}
                                />
                        }
                        <ActionsPanelItem
                            title="Delete Agent"
                            iconUrl="/assets/images/deleteIconColor.svg"
                            onClick={() => toggleDeleteAgentModal(true)}
                        />
                    </React.Fragment>
                }
                { isAdminAccount() ?
                    <ActionsPanelItem
                        title="Link Sites"
                        iconUrl="/assets/images/agentsitelink.svg"
                        onClick={() => toggleLinkSitesModal(true)}
                    />
                    : null
                
                }
                {
                    isFullHubAllowed && agent.serialNumber && currentUser.isSuperUser ?
                        <ActionsPanelItem
                            title="Stop Inventory Scan"
                            iconUrl="/assets/images/removeIconRed.svg"
                            onClick={() => handleStopInventoryScan(agent)}
                        />
                        : null
                }
            </div>
        </SidebarPanel>
    );
};

const mapStateToProps = state => ({
    currentUser:   state.currentUser,
    currentScopes: state.core.currentScopes
});

const mapDispatchToProps = {
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    stopInventoryScan
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentActionsPanel);
